import { render, staticRenderFns } from "./BlockRender.vue?vue&type=template&id=2090fa84&"
import script from "./BlockRender.vue?vue&type=script&lang=ts&"
export * from "./BlockRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports